import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Application from './Application';

ReactDOM.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>,
  document.getElementById('root')
);